<div class="my-aha-container">
  <div class="content-container">
    <app-icon
      class="link-device-icon"
      [icon]="'my-aha-link-tv-devices'"
    ></app-icon>
    <h2
      class="heading"
      [innerHTML]="'link_tv_title' | translate"
      [style]="'fontSize.48' | translate"
    ></h2>
    <p
      class="subtext"
      [innerHTML]="'link_tv_desc' | translate"
      [style]="'fontSize.28' | translate"
    ></p>
    <div class="button-container horizontal-focusable-container">
      <app-icon-button
        (keydown.ArrowLeft)="onArrowLeft()"
        [label]="'link_tv_header' | translate"
        [icon]="'my-aha-link-tv'"
        [mode]="'normal'"
        (clicked)="onLinkTvClick()"
        [gap]="'0.833vw'"
      >
      </app-icon-button>
    </div>
  </div>
  <div class="appVersion" [style]="'fontSize.24' | translate">
    {{ "appVersionLabel" | translate }} {{ appVersion }}
  </div>
</div>
